function wysiwyg_toggle(element) {
    if($('.wysiwyg_menu').length > 0) {
        var headnr = 1;

        $('.wysiwyg').each(function() {

            // Clear jquery scroll menu
            $('.wysiwyg_menu .list').empty()

            // Count h2's
            var h2_total = $(this).find('h2, .h2, .h3').length;

            // Run function on each h2
            $(this).find('h2, .h2, .h3').each(function(h2_index) {
                var wysiwyg_menu_link = $(this).text();
                var menu_row = '<li class="block v-padding-xs"><a data-scroll-link="heading-' + headnr + '" href="#heading-' + headnr + '">' + wysiwyg_menu_link + '</a></li>';

                // Add id's to headings
                $(this).attr('id', 'heading-' + headnr);

                // Copy h2 titles to scroll menu
                if(g_windowWidth > 959) {
                    $('.wysiwyg_menu .list').append(menu_row);
                }

                // Create js-text divs to toggle
                if(g_windowWidth < 960) {

                    // Hide h2 js-text divs
                    if(!$('.wysiwyg').hasClass('wysiwyg-toggled')) {

                        // Add js-toggle classes
                        $(this).addClass('js-toggle js-toggle-' + headnr);

                        // Wrap text in div's
                        $(this).nextUntil('h2, .h2, .h3').wrapAll('<div class="js-text js-text-' + headnr + ' js-hide"></div>');

                        // Add class to parent so the toggles wont be added twice
                        if (h2_index === h2_total - 1) {
                            $(this).parent().addClass('wysiwyg-toggled');
                        }
                    }

                } else {

                    if($('.wysiwyg').hasClass('wysiwyg-toggled')) {
                        var h2_text = $(this).nextAll('.js-text').html();

                        // Paste text after h2
                        $(this).after(h2_text);

                        // Remove js-text div and wysiwyg_toggled class
                        if (h2_index === h2_total - 1) {
                            $(this).parent().removeClass('wysiwyg-toggled');
                            $(this).parent().find('.js-text').remove();
                        }
                    }

                }

                headnr++;
            });

        });

        // Toggle items
        $('.wysiwyg').unbind().on('click', '.js-toggle:not(.no-toggle)', function() {
            var toggleTitle = $(this);

            $(this).toggleClass('js-toggle-active');
            $(this).next().toggleClass('js-hide');
        });

        // open first item
        $('.body_home').find('#heading-1').trigger('click').addClass('no-toggle');

        smoothScroll();
    }
}
